import { TemplateName } from '@/helpers/templateType';

export const MAIN_BUTTON_BEHAVIOR = {
  LINK  : 1,
  CLOSE : 2
};

export const NOTICE_TYPES = {
  STANDARD : 'standard',
  POP_UP   : 'popup',
  SURVEY   : 'survey',
  SUBJECT  : 'subject'
};

export const NOTICE_STATUS = {
  SCHEDULED : 'scheduled',
  PUBLISHED : 'published',
  DRAFT     : 'draft',
  HIDDEN    : 'hidden',
  UNDEFINED : 'undefined'
};

export const getNoticeOptions = (context) => {
  return [
    { id: NOTICE_TYPES.STANDARD, text: context.$t('noticeBoard.typeOptions.standard'), icon: 'mdi-inbox-full-outline' },
    { id: NOTICE_TYPES.POP_UP, text: context.$t('noticeBoard.typeOptions.popup'), icon: 'mdi-message-alert-outline' }
  ];
};

export const MAX_HIGHLIGHT_COUNT = 5;

export const NoticeColors = {
  DEFAULT : 'default',
  BLUE    : 'blue',
  GREEN   : 'green',
  RED     : 'red',
  YELLOW  : 'yellow'
};

export const NoticeVisibility = {
  VISIBLE       : 1,
  SCHEDULED     : 2,
  OUT_OF_PERIOD : 3
};

export const NoticeColorSchemes = {
  [TemplateName.TIMELINE]: {
    [NoticeColors.DEFAULT]: {
      color       : 'var(--v-neutrals-800-base)',
      border      : 'var(--v-neutrals-200-base)',
      background  : 'var(--v-neutrals-0-base)',
      buttonColor : 'default'
    },
    [NoticeColors.BLUE]: {
      color       : 'var(--v-info-base)',
      border      : 'var(--v-info-lighten3)',
      background  : 'var(--v-info-lighten5)',
      buttonColor : 'info'
    },
    [NoticeColors.GREEN]: {
      color       : 'var(--v-success-base)',
      border      : 'var(--v-success-lighten2)',
      background  : 'var(--v-success-lighten5)',
      buttonColor : 'success'
    },
    [NoticeColors.RED]: {
      color       : 'var(--v-error-base)',
      border      : 'var(--v-error-lighten3)',
      background  : 'var(--v-error-lighten5)',
      buttonColor : 'error'
    },
    [NoticeColors.YELLOW]: {
      color       : 'var(--v-warning-base)',
      border      : 'var(--v-warning-lighten2)',
      background  : 'var(--v-warning-lighten5)',
      buttonColor : 'warning'
    }
  },
  [TemplateName.STREAMING]: {
    [NoticeColors.DEFAULT]: {
      color       : '#FFFFFF',
      border      : '#5F5F6B',
      background  : '#1F1F27',
      buttonColor : 'default'
    },
    [NoticeColors.BLUE]: {
      color       : 'var(--v-info-base)',
      border      : 'var(--v-info-base)',
      background  : '#090F16',
      buttonColor : 'default'
    },
    [NoticeColors.GREEN]: {
      color       : 'var(--v-success-base)',
      border      : 'var(--v-success-base)',
      background  : '#1E232A',
      buttonColor : 'default'
    },
    [NoticeColors.RED]: {
      color       : 'var(--v-error-base)',
      border      : 'var(--v-error-base)',
      background  : '#251E25',
      buttonColor : 'default'
    },
    [NoticeColors.YELLOW]: {
      color       : 'var(--v-warning-base)',
      border      : 'var(--v-warning-base)',
      background  : '#242225',
      buttonColor : 'default'
    }
  }
};

export const NoticeHighlightedIcons = {
  DEFAULT     : 'default',
  ATTENTION   : 'attention',
  CHECK       : 'check',
  CLOCK       : 'clock',
  DELIVERY    : 'delivery',
  HOURGLASS   : 'hourglass',
  LOUDSPEAKER : 'loudspeaker',
  MESSAGE     : 'message',
  MESSAGES    : 'messages',
  PRESENT     : 'present',
  QUESTIONS   : 'questions',
  STAR        : 'star',
  STARS       : 'stars',
  TYPING      : 'typing',
  WARNING     : 'warning'
};
